<template lang="pug">
    v-container.exam-basic-container
        v-container.timer
            v-row
                v-col
                    v-btn(color='error' @click='backQuestions()' :disabled = 'backBtn') Volver    
                v-col
                    v-btn(color='primary' @click='nextQuestions()' :disabled = 'continueBtn') Continuar   
       
        v-container.exam-container
            form
                template(v-for='(q,i) in renderQuestions')
                    v-row
                        v-col
                            v-row(:class='[ q.correct ? "success" : "error"]')
                                | {{ q.desc }}
                            v-row
                                template(v-if='q.ans_type == 1')
                                    v-radio-group(v-model='answers[`${q.id}`]')
                                        v-radio(v-for='(a,ia) in q.answers' :key='ia' :label='`${a.desc}`' :value='ia' disabled='' selected='0')
                                            template(v-slot:label)
                                                | {{ a.desc }}
                                                v-icon.check-ans(v-if='ia == correct_answers[`${q.id}`]' color='success')
                                                    | check
                                template(v-if='q.ans_type == 2')
                                    v-radio-group(v-model='answers[`${q.id}`]' :multiple='true')
                                        v-radio(v-for='(a,ia) in q.answers' :key='ia' :label='`${a.desc}`' :value='ia' disabled='')
</template>

<script>
import { config } from '../config.js'
import Timer from '../components/Timer'

export default {
    components:
    {
        Timer
    },
    created () {
    },
    mounted(){
      console.log('Props: ', this.$route.query.id);
      this.$emit("loadingEvent", true);
      if(this.$route.query.id){
        this.eval_id = this.$route.query.id;
        this.initialize();
      }else{
        this.$emit("loadingEvent", false);
        this.$router.push({ name: 'home' });
      }
    },
    data: () => ({
        exam: {},
        eval_id:'',
        exam_id: '',
        dateDeadline: '',
        continueBtn: false,
        backBtn: true,
        counter: 5,
        lastIndex: 0, 
        renderQuestions: [],
        warnContinue: false,
        warnFinalize: false,
        warnDeadline: false,
        warnInit: false,
        questions:[],
        answers:{ },
        correct_answers:{ }
    }),

    methods: {
        initialize () {

            let _this = this;
            console.log('Initializate evaluation')

            this.axios.get(`${config.serviceUri}evaluations?id=${this.eval_id}`)
            .then( (response) => {
                console.log('Succes request: ',response.data);
                _this.evaluation = response.data.payload;

                _this.questions = [];

                _this.evaluation.questions.forEach( q => {
                    let temp_q = q.question;
                    temp_q.correct = q.question.answers.findIndex( t => t.correct) == q.user_val;
                    _this.questions.push(temp_q);
                    _this.answers[q.question.id] = q.user_val;
                    _this.correct_answers[q.question.id] = q.question.answers.findIndex( t => t.correct);
                })
                
                _this.getRenderQuestions();
                _this.$emit("loadingEvent", false);
            })
            .catch( (error) => {
                console.log('Error: ', error);
                _this.$emit("loadingEvent", false);
                _this.$router.push({ name: 'home' });
            });
        },
        getRenderQuestions(startIndex = 0){
            let endIndex = startIndex + this.counter;
            if(startIndex >= 5){
                this.backBtn = false;
            }else if(startIndex == 0){
                this.backBtn = true;
            }
            if(this.questions.slice(startIndex, endIndex).length > 0){
                this.renderQuestions = this.questions.slice(startIndex, endIndex);
                this.lastIndex = endIndex;
            }else{
                this.continueBtn = true;
            }
        },
        backQuestions(){
            this.getRenderQuestions(this.lastIndex - 10);
        },
        nextQuestions(){
            this.getRenderQuestions(this.lastIndex);
        },
        backHome(){
            this.$router.push({ name: 'home' })
        },
        initExam(){
            this.$emit("loadingEvent", true);
            this.initialize();
        }
    }
}
</script>

<style scoped>
.timer{
    margin: 5% 2.5% 0 0;
    width: 300px;
    max-width: 20%;
    max-height: 20%;
    background: #ffffff;
    position: fixed;
    right: 0;
    top: 0;
/* 
    -webkit-box-shadow: -2px 10px 33px -3px rgba(0,0,0,0.75);
    -moz-box-shadow: -2px 10px 33px -3px rgba(0,0,0,0.75);
    box-shadow: -2px 10px 33px -3px rgba(0,0,0,0.75); */
}

.exam-container{
    width: 60%;
    margin: 5% 20%;
    padding: 40px;
    background: #ffffff;
    
}

.text-warn{
    text-align: center;
    color: black;
    font-size: 1rem;
}

.init-dialog .v-overlay__scrim{
    background: green !important;
}
.check-ans{
    color: green !important;
}

.theme--light.v-radio--is-disabled .v-icon {
    color: green !important;
}
</style>
